export const BitcoinAppConfig = {
  btnChangingTimeout: 5000,
  popupBtnShowingTimeout: 5000,
  depositShortName: {
    pyusd: 'paypal_pyusd',
    cashAppBitcoin: 'cashapp_bitcoin',
    cashAppUSDC: 'cashapp_usdc'
  }
}
